import Vue from 'vue';

import App from './App.vue';
// Vue Router
import router from '@/router';
// Vuex Store
import store from '@/store';


// ========================================
//
// Setup Add
//
// ========================================
// axios Add
import axios from "./setup/axios-setup";

import $context from "./app-context";
import $cache from "./cache";

// Multi Language Add
import { i18n } from './setup/i18n-setup';
// Apollo Add
import {apolloProvider} from './setup/apollo-setup';
import TreeView from "vue-json-tree-view";

// Form Validation Add
import '@/setup/vee-validate-setup';
// Global Components Add
import '@/setup/global-components-setup';
// Theme Add
import '@/setup/theme-setup';
// Filter Add
import './setup/filter-setup'
// Plugin Add
import '@/setup/plugin-setup'

Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.$context = $context;
Vue.prototype.$currentUser = { active: false };
Vue.prototype.$flatmap = $cache.$flatmap;
Vue.prototype.$cache = $cache;

// Theme Configurations
// import '../themeConfig.js'


// import Vuex from 'vuex'


Vue.use(TreeView);

Vue.config.productionTip = false;

const vm = new Vue({
  i18n,
  apolloProvider,
  router,
  store,
  render: h => h(App)
}).$mount('#app');

export default vm;


/*
  For help debugging, don't remove
*/
if (process.env.VUE_APP_DEPLOYMENT_STAGE === "development"
  || process.env.VUE_APP_LOCAL_SERVER === "true") {
  console.log("DEBUG: Environment Variables", process.env) // eslint-disable-line no-console
}
